export const createSortParam = ({
  field,
  desc,
}: {
  field: string;
  desc?: boolean;
}) => {
  return `${field},${desc ? "desc" : "asc"}`;
};
